/**
 * @Author: wuyang
 * @Date: 2024/1/12
 * @Description: ""
 */

import React, { FC, PropsWithChildren } from 'react'
import { Outlet } from 'react-router'
import { DataXHeader } from '@/business-component/data-x-header/DataXHeader'
import { DataXFooter } from '@/business-component/data-x-footer/DataXFooter'
import { Affix } from 'antd'

export const DataXDocsLayout: FC<PropsWithChildren<{}>> = (props) => {
	return (
		<div className="bg-normal flex flex-col min-h-[100vh]">
			<Affix offsetTop={0}>
				<DataXHeader />
			</Affix>
			<div className="flex-1">
				<Outlet></Outlet>
			</div>
			<DataXFooter />
		</div>
	)
}
